module.exports = __webpack_public_path__ + "img/1723599329930-image.jpg.0492943b.webp";